<template>
  <hm-content title="" :hidden="hidden">
    <div class="table-panel flex flex-between">
      <div>
        <el-radio-group
          v-model="searchCondition.subjectName"
          size="small"
          @change="subjectTypeChange"
        >
          <el-radio-button
            v-for="(v, i) in subjectTypeList"
            :key="i"
            :label="v.itemValue"
            >{{ v.itemText }}</el-radio-button
          >
        </el-radio-group>
      </div>
      <div>
        <!-- <el-select
          size="small"
          class="mr10"
          placeholder="请选择主体类型"
          v-model="searchCondition.subjectName"
          filterable
        >
          <el-option
            :label="v.itemText"
            :value="v.itemValue"
            v-for="(v, i) in subjectTypeList"
            :key="i"
          >
          </el-option>
        </el-select> -->
        <el-date-picker
          class="mr10"
          size="small"
          v-model="searchCondition.applyDate"
          type="daterange"
          range-separator="至"
          start-placeholder="选择创建时间段"
          end-placeholder="选择创建时间段"
        ></el-date-picker>

        <el-button type="primary" size="small" @click="search">查询</el-button>
        <el-button
          type="success"
          size="small"
          @click="output"
          :loading="isOutputing"
          >导出</el-button
        >
      </div>
    </div>
    <div class="table">
      <el-table
        :data="list"
        style="width: 100%"
        ref="table"
        stripe
        border
        size="small"
        height="600"
      >
        <el-table-column
          header-align="center"
          align="center"
          type="index"
          label="序号"
          width="50"
          fixed
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          fixed
          header-align="center"
          align="center"
          label="日期"
          prop="pubDate"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="主体类型"
          prop="subjectName"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="初期余额（元）"
          prop="openingBalance"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="收入（元）"
          prop="revenueAmount"
        >
          <template slot-scope="scope">
            <div class="success">+{{ scope.row.revenueAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="收入笔数"
          prop="revenueNum"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="支出（元）"
          prop="paidAmount"
        >
          <template slot-scope="scope">
            <div class="danger">-{{ scope.row.paidAmount }}</div>
          </template>
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="支出笔数"
          prop="paidNum"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          label="日终余额（元）"
          prop="closingBalance"
        ></el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="orderSn"
          label="操作"
        >
          <template slot-scope="scope">
            <div class="flex flex-center">
              <el-button
                size="small"
                type="text"
                @click="toDetails('commission', '导购提成明细', scope.row)"
                >业务汇总单
              </el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
    <el-dialog
      title="业务汇总单"
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
    >
      <div class="table-panel flex flex-between">
        <div>主体类型：{{ row.subjectName }}</div>
        <!-- <el-input
          size="small"
          clearable
          style="width:300px"
          class="mr10 ipt"
          v-model.trim="searchConditionDetail.keyWords"
          placeholder="导购名称"
        ></el-input> -->
        <div>
          <el-date-picker
            class="mr10"
            size="small"
            v-model="searchConditionDetail.applyDate"
            type="daterange"
            value-format="yyyy-MM-dd"
            range-separator="至"
            start-placeholder="选择时间段"
            end-placeholder="选择时间段"
          ></el-date-picker>
          <el-button type="primary" size="small" @click="searchDetails"
            >查询</el-button
          >
        </div>
      </div>
      <div class="table-panel flex flex-between">
        <div>
          <el-radio-group
            v-model="searchConditionDetail.tradeMode"
            size="small"
            @change="tradeModeChange"
          >
            <el-radio-button label="in">收入</el-radio-button>
            <el-radio-button label="out">支出</el-radio-button>
          </el-radio-group>
          <!-- 账目类型：
          <el-select
            size="small"
            class="mr10"
            placeholder="请选择账目类型"
            v-model="searchConditionDetail.tradeMode"
            filterable
          >
            <el-option label="收入" value="in"> </el-option>
            <el-option label="支出" value="out"> </el-option>
          </el-select> -->
        </div>
        <div>
          <el-button
            type="success"
            size="small"
            @click="outputDetail"
            :loading="isOutputing"
            >下载账单</el-button
          >
          <el-button
            type="success"
            size="small"
            @click="outputAllDetail(row.subjectName)"
            >下载{{ row.subjectName }}明细</el-button
          >
        </div>
      </div>
      <div class="table">
        <el-table
          :data="detailList"
          style="width: 100%"
          ref="detailstable"
          stripe
          border
          size="small"
        >
          <el-table-column
            header-align="center"
            align="center"
            type="index"
            label="序号"
            width="50"
            :index="
              index => index + (currentPageDetail - 1) * pageSizeDetail + 1
            "
          ></el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="日期"
            prop="pubDate"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="账目"
            prop="itemName"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="账目类型"
            prop="tradeMode"
          >
            <template slot-scope="scope">
              {{ scope.row.tradeMode === "in" ? "收入" : "支出" }}
            </template>
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="金额"
            prop="itemValue"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="笔数"
            prop="itemNum"
          >
          </el-table-column>
          <el-table-column
            header-align="center"
            align="center"
            label="流向"
            prop="subjectName"
          >
            <template slot-scope="scope">
              {{ row.subjectName
              }}{{ scope.row.tradeMode === "in" ? "收入" : "支出" }}
            </template>
          </el-table-column>
        </el-table>
        <!-- <div class="form-red" v-if="row.subjectName === '商户'">
          商户业务明细下载内容——充值中心，充值流水+扣减流水
          供应商资金流水，充值流水+红包流水.（下载含有三个维度的sheet表，以筛选时间为准，不区分商户）
        </div>
        <div class="form-red" v-if="row.subjectName === '禾苗'">
          商户业务明细下载内容——充值中心，充值流水+扣减流水
          供应商资金流水，充值流水+红包流水.（下载含有三个维度的sheet表，以筛选时间为准，不区分商户）
        </div>
        <div class="form-red" v-if="row.subjectName === '商户'">
          商户业务明细下载内容——充值中心，充值流水+扣减流水
          供应商资金流水，充值流水+红包流水.（下载含有三个维度的sheet表，以筛选时间为准，不区分商户）
        </div> -->
      </div>
      <!-- <div v-if="type === 'commission'">
        <div class="table">
          <el-table
            :data="detailList"
            style="width: 100%"
            :ref="type"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageDetail - 1) * pageSizeDetail + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="导购"
              prop="guiderName"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="商户"
              prop="storeName"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="门店"
              prop="shopName"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="申报单号"
              prop="receiptSn"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="小票号"
              prop="receiptSn"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="申报时间"
              prop="declareTime"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放时间"
              prop="tradeTime"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放金额"
              prop="redpackageMoneySum"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="type === 'share'">
        <div class="table">
          <el-table
            :data="detailList"
            style="width: 100%"
            :ref="type"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageDetail - 1) * pageSizeDetail + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="会员"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="所属商城"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="订单号"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="佣金类型"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="佣金状态"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="佣金金额"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="流水发生时间"
              prop="supplierRedpackage"
            >
            </el-table-column>
          </el-table>
        </div>
      </div>
      <div v-if="type === 'withdrawal'">
        <div class="table">
          <el-table
            :data="detailList"
            style="width: 100%"
            :ref="type"
            stripe
            border
            size="small"
          >
            <el-table-column
              header-align="center"
              align="center"
              type="index"
              label="序号"
              width="50"
              :index="
                index => index + (currentPageDetail - 1) * pageSizeDetail + 1
              "
            ></el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="提现单号"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="申请人"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="申请时间"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放时间"
              prop="supplierRedpackage"
            >
            </el-table-column>
            <el-table-column
              header-align="center"
              align="center"
              label="发放金额"
              prop="supplierRedpackage"
            >
            </el-table-column>
          </el-table>
        </div>
      </div> -->
      <div class="hm-pagination">
        <el-pagination
          background
          :total="totalDetail"
          @current-change="pagingDetail"
          @size-change="handleSizeChangeDetail"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPageDetail"
        ></el-pagination>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
export default {
  components: {},
  data() {
    return {
      hidden: true,
      dialogVisible: false,
      title: "",
      type: "",
      isOutputing: false,
      list: [],
      currentPage: 1,
      pageSize: 20,
      total: 0,
      searchCondition: {
        subjectName: "",
        applyDate: []
      },
      searchConditionDetail: {
        applyDate: [],
        tradeMode: "in"
      },
      detailList: [],
      currentPageDetail: 1,
      pageSizeDetail: 10,
      totalDetail: 0,
      row: {},
      subjectTypeList: []
    };
  },
  computed: {},
  watch: {},
  created() {},
  mounted() {
    this.searchCondition.applyDate = [
      `${this.getDay(-6)}`,
      `${this.getDay(0)}`
    ];
    this.querySubjectType();
  },
  methods: {
    tradeModeChange() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    subjectTypeChange() {
      this.currentPage = 1;
      this.queryList();
    },
    async querySubjectType() {
      const { result } = await this.$store.dispatch("subjectAllType");
      this.subjectTypeList = result;
      this.searchCondition.subjectName = result[0].itemValue;
      this.queryList();
    },
    getDay(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds); //注意，这行是关键代码
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      return tYear + "-" + tMonth + "-" + tDate;
    },
    doHandleMonth(month) {
      let m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    toDetails(type, title, row) {
      this.row = row;
      this.searchConditionDetail = {
        applyDate: [],
        tradeMode: "in"
      };
      this.detailList = [];
      this.currentPageDetail = 1;
      this.pageSizeDetail = 10;
      this.totalDetail = 0;
      this.type = type;
      //   this.title = title;
      this.searchConditionDetail.applyDate = [row.pubDate, row.pubDate];
      this.dialogVisible = true;
      this.queryDetailList();
    },

    // 导出excel
    output() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllList()
          .then(res => {
            let list = res;
            let tHeader = this.$refs.table.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.table.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }

            let title = "系统对账";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    outputDetail() {
      require.ensure([], () => {
        const { exportJsonToExcel } = require("@/utils/output/Export2Excel");
        this.isOutputing = true;

        this.queryAllDetailList()
          .then(res => {
            let list = res;
            let title = "";
            list.forEach(v => {
              if (v.tradeMode === "in") {
                v.tradeMode = "收入";
                v.subjectName = this.row.subjectName + v.tradeMode;
              } else {
                v.tradeMode = "支出";
                v.subjectName = this.row.subjectName + v.tradeMode;
              }
              title =
                this.searchConditionDetail.applyDate + v.subjectName + "账单";
            });
            let tHeader = this.$refs.detailstable.columns
              .map(o => o.label !== "序号" && o.label !== "操作" && o.label)
              .filter(o => o);

            let filterVal = [];
            if (list.length > 0) {
              filterVal = this.$refs.detailstable.$children
                .map(o => o._props.prop)
                .filter(o => o);
            }
            // let title = "系统对账";

            let data = this.formatJson(filterVal, list);

            exportJsonToExcel(
              tHeader,
              data,
              title + new Date().toLocaleString()
            );
            this.isOutputing = false;
          })
          .catch(() => {
            this.isOutputing = false;
          });
      });
    },
    outputAllDetail(subjectName) {
      if (subjectName === "禾苗") {
        this.queryHmDetails();
      } else if (subjectName === "商户") {
        this.exportStoreDetails();
      } else if (subjectName === "导购") {
        this.exportGuiderDetails();
      }
      this.hidden = false;
      this.$message({
        message: "已加入导出队列，请在导出列队中查看！",
        type: "success"
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]));
    },
    async queryHmDetails() {
      // let params = {
      //   pageNo: this.currentPage,
      //   pageSize: this.pageSize
      // };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDetail)
      );
      searchCondition.pubStartDate =
        this.searchConditionDetail.applyDate &&
        this.searchConditionDetail.applyDate.length > 0
          ? this.searchConditionDetail.applyDate[0]
          : "";
      searchCondition.pubEndDate =
        this.searchConditionDetail.applyDate &&
        this.searchConditionDetail.applyDate.length > 0
          ? this.searchConditionDetail.applyDate[1]
          : "";

      searchCondition.subjectName = this.row.subjectName;
      this.$store.dispatch("exportHemiaoDetails", searchCondition);
      // if (code === "0") {
      // }
    },
    async exportStoreDetails() {
      // let params = {
      //   pageNo: this.currentPage,
      //   pageSize: this.pageSize
      // };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDetail)
      );
      searchCondition.pubStartDate =
        this.searchConditionDetail.applyDate &&
        this.searchConditionDetail.applyDate.length > 0
          ? this.searchConditionDetail.applyDate[0]
          : "";
      searchCondition.pubEndDate =
        this.searchConditionDetail.applyDate &&
        this.searchConditionDetail.applyDate.length > 0
          ? this.searchConditionDetail.applyDate[1]
          : "";

      searchCondition.subjectName = this.row.subjectName;
      this.$store.dispatch("exportStoreDetails", searchCondition);
      // if (code === "0") {
      //   this.hidden = false;
      //   this.$message({
      //     message: "已加入导出队列，请在导出列队中查看！",
      //     type: "success"
      //   });
      // }
    },
    async exportGuiderDetails() {
      // let params = {
      //   pageNo: this.currentPage,
      //   pageSize: this.pageSize
      // };
      const searchCondition = JSON.parse(
        JSON.stringify(this.searchConditionDetail)
      );
      searchCondition.pubStartDate =
        this.searchConditionDetail.applyDate &&
        this.searchConditionDetail.applyDate.length > 0
          ? this.searchConditionDetail.applyDate[0]
          : "";
      searchCondition.pubEndDate =
        this.searchConditionDetail.applyDate &&
        this.searchConditionDetail.applyDate.length > 0
          ? this.searchConditionDetail.applyDate[1]
          : "";

      searchCondition.subjectName = this.row.subjectName;
      this.$store.dispatch("exportGuiderDetails", searchCondition);
      // if (code === "0") {
      //   this.hidden = false;
      //   this.$message({
      //     message: "已加入导出队列，请在导出列队中查看！",
      //     type: "success"
      //   });
      // }
    },
    async queryList() {
      if (this.searchCondition.applyDate.length) {
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.pubStartDate =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.pubEndDate =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch(
          "queryPubCapitalFlowList",
          params
        );
        const { records, total } = result;
        this.list = records;
        this.total = total;
      } else {
        this.$message({
          message: "请选择对账时间段！",
          type: "warning"
        });
      }
    },
    async queryAllList() {
      if (this.searchCondition.applyDate.length) {
        let params = {
          pageNo: 1,
          pageSize: 999999
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.pubStartDate =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[0]
            : "";
        searchCondition.pubEndDate =
          this.searchCondition.applyDate &&
          this.searchCondition.applyDate.length > 0
            ? this.searchCondition.applyDate[1]
            : "";
        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch(
          "queryAllPubCapitalFlowList",
          params
        );
        return result.records;
      } else {
        this.$message({
          message: "请选择对账时间段！",
          type: "warning"
        });
      }
    },
    async queryDetailList() {
      if (this.searchConditionDetail.applyDate.length) {
        let params = {
          pageNo: this.currentPageDetail,
          pageSize: this.pageSizeDetail,
          subjectName: this.row.subjectName
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchConditionDetail)
        );
        searchCondition.pubStartDate =
          this.searchConditionDetail.applyDate &&
          this.searchConditionDetail.applyDate.length > 0
            ? this.searchConditionDetail.applyDate[0]
            : "";
        searchCondition.pubEndDate =
          this.searchConditionDetail.applyDate &&
          this.searchConditionDetail.applyDate.length > 0
            ? this.searchConditionDetail.applyDate[1]
            : "";
        //   searchCondition.pubStartDate = `${this.row.pubDate}`;
        //   searchCondition.pubEndDate = `${this.row.pubDate}`;

        Object.assign(params, searchCondition);

        const { result } = await this.$store.dispatch(
          "queryDaySubjeckCapitalList",
          params
        );
        const { records, total } = result;
        this.detailList = records;
        this.totalDetail = total;
      } else {
        this.$message({
          message: "请选择时间段查询！",
          type: "warning"
        });
      }
    },
    async queryAllDetailList() {
      if (this.searchConditionDetail.applyDate.length) {
        let params = {
          pageNo: 1,
          pageSize: 999999,
          subjectName: this.row.subjectName
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchConditionDetail)
        );
        searchCondition.pubStartDate =
          this.searchConditionDetail.applyDate &&
          this.searchConditionDetail.applyDate.length > 0
            ? this.searchConditionDetail.applyDate[0]
            : "";
        searchCondition.pubEndDate =
          this.searchConditionDetail.applyDate &&
          this.searchConditionDetail.applyDate.length > 0
            ? this.searchConditionDetail.applyDate[1]
            : "";
        //   searchCondition.pubStartDate = `${this.row.pubDate}`;
        //   searchCondition.pubEndDate = `${this.row.pubDate}`;

        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch(
          "queryAllDaySubjeckCapitalList",
          params
        );
        return result.records;
      } else {
        this.$message({
          message: "请选择时间段查询！",
          type: "warning"
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    searchDetails() {
      this.currentPageDetail = 1;
      this.queryDetailList();
    },
    pagingDetail(page) {
      this.currentPageDetail = page;
      this.queryDetailList();
    },
    handleSizeChangeDetail(size) {
      this.currentPageDetail = 1;
      this.pageSizeDetail = size;
      this.queryDetailList();
    }
  }
};
</script>
<style lang="scss" scoped></style>
